<div id="lista" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

                <!-- HEADER -->
        <div class="header accent"
        fxLayout="column" fxLayoutAlign="center center"
        fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

        <!-- TÍTULO E BOTÃO -->
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
        <!-- TÍTULO -->
        <div class="logo mb-24 mb-md-0"
                fxLayout="row" fxLayoutAlign="start center">
            <mat-icon class="logo-icon s-32 mr-16">
                business
            </mat-icon>
            <span class="logo-text h1">
                Histórico de Movimentações
            </span>
        </div>
        <!-- / TÍTULO -->

        <!-- BOTÃO CONSULTAR -->
        <button mat-mini-fab
                color="accent"
                matTooltip="Consultar Histórico"
                (click)="openFiltro()"
                style="margin-left: 16px;">
            <mat-icon>search</mat-icon>
        </button>
        <!-- / BOTÃO CONSULTAR -->
        </div>
        <!-- / TÍTULO E BOTÃO -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <ngx-datatable 
                #table 
                class='material striped' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"                       
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'>

                <ngx-datatable-column name="Data" prop="data_operacao" [sortable]="false" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-data_operacao="value" ngx-datatable-cell-template>
                        {{data_operacao | date:'dd/MM/yyyy H:mm'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Sócio Responsável" prop="operador" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-operador="value" ngx-datatable-cell-template>
                        {{operador.name}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Escritório" prop="cliente" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                        {{cliente.escritorio.nome_fantasia}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                        {{cliente.numero_xp}} - {{cliente.nome}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Valor" prop="row" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template >
                        <span>R$ {{row.valor | number : '1.2-2'}}</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Tipo Operação" prop="row" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template >
                        <span>{{getTipo(row)}}</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Tipo Movimentação" prop="row" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template >
                        <span>{{ row.tipo_movimentacao }}</span>
                    </ng-template>
                </ngx-datatable-column>

                <!--<ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                        <button mat-icon-button matTooltip="Visualizar" (click)="openVisualizar(id)">
                            <mat-icon aria-label="Visualizar">search</mat-icon>
                        </button>                       
                    </ng-template>
                </ngx-datatable-column>-->

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator #paginator [length]="length"
                            [pageSize]="pageSize"
                            [pageSizeOptions]="pageSizeOptions"
                            (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>